import React from "react";
import { useNavigate } from "react-router-dom";
import { History, Route, LifeBuoy, LogOut, Building2, Link as LinkIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import UserMenu from "@/components/UserMenu";

/**
 * HotelProfileMenu — dropdown for the hotel dashboard.
 * Groups: Multi-destination, Historique, Lien public, Aide, Déconnexion.
 * Replaces the pill-nav row + logout that used to sit spread across the
 * hotel top-bar.
 */
export default function HotelProfileMenu({ onOpenHelp, onOpenPublicLink }) {
  const nav = useNavigate();
  const { logout, profile } = useAuth();

  const hotelName = profile?.name || profile?.hotel_name || "Hôtel Price";
  const initials = (hotelName || "H")
    .split(" ")
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const items = [
    {
      icon: <Route className="h-4 w-4" />,
      label: "Multi-destination",
      hint: "Réservation à étapes",
      onClick: () => nav("/dashboard/hotel/multi-destination"),
      testId: "hotel-menu-multi",
    },
    {
      icon: <History className="h-4 w-4" />,
      label: "Historique",
      hint: "Mes courses",
      onClick: () => nav("/dashboard/hotel/history"),
      testId: "hotel-menu-history",
    },
    {
      icon: <LinkIcon className="h-4 w-4" />,
      label: "Lien réception",
      hint: "Partager avec un client",
      onClick: onOpenPublicLink,
      testId: "hotel-menu-public-link",
    },
    {
      icon: <LifeBuoy className="h-4 w-4" />,
      label: "Aide",
      hint: "Contact 24/7",
      onClick: onOpenHelp,
      testId: "hotel-menu-help",
    },
    {
      icon: <LogOut className="h-4 w-4" />,
      label: "Déconnexion",
      danger: true,
      onClick: async () => {
        try { await logout?.(); } catch (_) { /* ignore */ }
        window.location.assign("/");
      },
      testId: "hotel-menu-logout",
    },
  ];

  return (
    <UserMenu
      avatarText={initials || <Building2 className="h-4 w-4" />}
      title={hotelName}
      subtitle={profile?.email || ""}
      items={items}
      testId="hotel-menu-btn"
      panelTestId="hotel-profile-menu"
    />
  );
}
